var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0"},[_c('background'),_c('famous-saying'),_c('challenge-progress'),_c('reward')],1)}
var staticRenderFns = []

export { render, staticRenderFns }